import { createAction } from '@reduxjs/toolkit';
import constants from '../tags.constants';

export const showCreateRecommendationButton = createAction<boolean>(constants.SHOW_CREATE_RECOMMENDATION_BUTTON);
export const changeCurrentTab = createAction<string>(constants.CHANGE_CURRENT_TAB);
export const changeDrawerTitle = createAction<string>(constants.CHANGE_DRAWER_TITLE);
export const storeBasePath = createAction<string>(constants.STORE_BASE_PATH);
